module.exports = __webpack_public_path__ + "static/media/datasheet_topScorerData_row3_certificate2.ac883f8f.png";